export const COLLAPSED_ROW_HEIGHT = '100px';
export const EXPANDED_ROW_HEIGHT = '200px';

export const MOBILE_COLLAPSED_ROW_HEIGHT = '120px';
export const MOBILE_EXPANDED_ROW_HEIGHT = '210px';

export const MOBILE_COLLAPSED_PP_ROW_HEIGHT = '150px';
export const MOBILE_EXPANDED_PP_ROW_HEIGHT = '230px';
export const MOBILE_BASE_VIEW_ONLY_HEIGHT = '80px';
